import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "e-application-wrapper" }
const _hoisted_2 = { class: "e-application-wrapper__card" }
const _hoisted_3 = { class: "e-application-wrapper__card-header" }
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(['e-application-wrapper__card-header-title'])
}
const _hoisted_5 = {
  key: 0,
  class: "stepHeader"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", { class: "line" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "1", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("small", { class: "line" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "2", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "3", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "e-application-wrapper__card-header-description" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "e-application-wrapper__card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Step3 = _resolveComponent("Step3")!
  const _component_Step4 = _resolveComponent("Step4")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(_ctx.getTitle)), 1),
          (_ctx.step !== 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    class: _normalizeClass({ selected: _ctx.step === 1, completed: _ctx.step > 1 })
                  }, _hoisted_8, 2),
                  _createElementVNode("li", {
                    class: _normalizeClass({ selected: _ctx.step === 2, completed: _ctx.step > 2 })
                  }, _hoisted_11, 2),
                  _createElementVNode("li", {
                    class: _normalizeClass({ selected: _ctx.step === 3 })
                  }, _hoisted_13, 2)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.step === 1)
            ? (_openBlock(), _createElementBlock("label", _hoisted_15, _toDisplayString(_ctx.$t("forms.application_forum.title_description")), 1))
            : _createCommentVNode("", true),
          _createElementVNode("hr", {
            class: _normalizeClass(['primaryShort', { 'primaryShort--step1': _ctx.step === 1 }])
          }, null, 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _renderSlot(_ctx.$slots, "body", { ref: "component" }),
        (_ctx.step === 1)
          ? (_openBlock(), _createBlock(_component_Step1, {
              key: 0,
              onNextPage: _ctx.toStepTwo,
              onPrevPage: _ctx.prevPage,
              application: _ctx.application
            }, null, 8, ["onNextPage", "onPrevPage", "application"]))
          : _createCommentVNode("", true),
        (_ctx.step === 2)
          ? (_openBlock(), _createBlock(_component_Step2, {
              key: 1,
              onNextPage: _ctx.toStepThree,
              onPrevPage: _ctx.prevPage
            }, null, 8, ["onNextPage", "onPrevPage"]))
          : _createCommentVNode("", true),
        (_ctx.step === 3)
          ? (_openBlock(), _createBlock(_component_Step3, {
              key: 2,
              paymentMethod: _ctx.paymentMethod,
              onNextPage: _ctx.submit,
              onPrevPage: _ctx.prevPage
            }, null, 8, ["paymentMethod", "onNextPage", "onPrevPage"]))
          : _createCommentVNode("", true),
        (_ctx.step === 4)
          ? (_openBlock(), _createBlock(_component_Step4, { key: 3 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}